import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7193c93e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "redial-call" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "logo",
  src: "/uidesk.png",
  alt: "",
  srcset: ""
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text" }, "Press the button to call", -1))
const _hoisted_4 = {
  class: "call-key",
  width: "44",
  height: "44"
}
const _hoisted_5 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", {
      class: "call-button",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.redial && _ctx.redial(...args))),
      tabindex: "0"
    }, [
      (_openBlock(), _createElementBlock("svg", _hoisted_4, [
        _createElementVNode("use", { href: '/icons.svg#call-button' }, null, 8, _hoisted_5)
      ]))
    ])
  ]))
}